import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class TableSlidesInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        console.log('codeeeeee0',this.props.data)
        return (
            <div className={`w-100 h-100 text-start ${this.props.onTable ? "" : 'flexcc'}`}>
                <p className="" style={{ color: this.props.onTable ? '#000' : '#474747', fontSize: this.props.onTable ? '' : "14px", textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: "wrap", }}>{this.props.data != null ? checkTranslation(String(this.props.data)) : ' '}</p>
            </div>
        )
    }
}

export default TableSlidesInput;